export default {
    items: [],
    fetching: false,
    selected: ''
};
